import { render, staticRenderFns } from "./nfcOrdersList.vue?vue&type=template&id=1c711592&scoped=true"
import script from "./nfcOrdersList.vue?vue&type=script&lang=js"
export * from "./nfcOrdersList.vue?vue&type=script&lang=js"
import style0 from "./nfcOrdersList.vue?vue&type=style&index=0&id=1c711592&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c711592",
  null
  
)

export default component.exports